// ── הקוד על המדבקה — בנקודות של המדפסת ─────────────────────────────────────
//
// אלי, 29/09/2026: „המדבקות עדיין לא באיכות ויזואלית טובה. במיוחד לא
// בלייזר." ואחר כך: „יש לי סורק QR".
//
// ── מה נמדד ──────────────────────────────────────────────────────────────
//
// XP-365B מדפיסה ב-203dpi — 8 נקודות למ״מ. Code128 של `260169.02.04.01.01|1`
// הוא 233 מודולים, והוא נמתח (PNG, `object-fit: fill`) על 44 מ״מ = 352
// נקודות: **1.5 נקודות לקו**. חלק מהקווים יצאו 1 נקודה וחלק 2 — פסים לא
// אחידים, מטושטשים, ועל 40×20 (1.3 נקודות לקו) מתחת למה שמדפסת תרמית
// מדפיסה בכלל. זה לא עניין של גופן; הקוד עצמו אינו נכנס.
//
// ── ומה במקום ────────────────────────────────────────────────────────────
//
// QR של אותו מטען הוא 25×25 מודולים. בשלוש נקודות למודול הוא 9.4 מ״מ —
// ריבוע קטן וחד שמשאיר למק״ט את כל הרוחב. וכל מודול הוא **מספר שלם של
// נקודות**, ולכן אין מתיחה ואין קווים לא אחידים. ה-SVG מצויר ישירות
// ברזולוציה של המדפסת.

/** 203dpi = 8 נקודות למ״מ. */
export const DOTS_PER_MM = 8;

/**
 * כמה מודולים יש ל-QR של הטקסט, ב-ECC M ובמצב בתים — מה שהשרת מייצר
 * (`qrSvg`, `eclevel: 'M'`).
 *
 * ⚠ אם bwip בוחר מצב צפוף יותר (ספרות בלבד), ה-QR יוצא קטן ממה שחושב
 * כאן — והוא עדיין נמתח לתיבה כווקטור, כך שהטעות היא חדות של שבר נקודה
 * ולא ברקוד שבור. הכיוון ההפוך (QR גדול מהתיבה) אינו אפשרי: מצב בתים
 * הוא הפחות צפוף.
 */
const QR_M_BYTES = [14, 26, 42, 62, 84, 106, 122, 152, 180, 213, 251, 287];
export function qrModules(text: string): number {
  const bytes = new TextEncoder().encode(text).length;
  const v = QR_M_BYTES.findIndex((cap) => bytes <= cap);
  return 17 + 4 * ((v < 0 ? QR_M_BYTES.length - 1 : v) + 1);
}

/** גודל ה-QR במ״מ כשכל מודול הוא `dots` נקודות מדפסת. */
export function qrSizeMm(text: string, dots: number): number {
  return (qrModules(text) * dots) / DOTS_PER_MM;
}

/** אותו origin, כדי שהעוגייה תיסע איתו. אנונימי — הלייזר קיוסק. */
export const qrSvgSrc = (text: string): string =>
  `/api/support/qr.svg?text=${encodeURIComponent(text)}`;

export const barcodeSvgSrc = (text: string): string =>
  `/api/support/barcode.svg?text=${encodeURIComponent(text)}`;
